import React from 'react';
import './NewProfileCard.css';

// props로 profile 데이터와 children을 받습니다.
function NewProfileCard({ profile, children }) {
  return (
    <div className="new-profile-display-card">
      <h2>🎉 당신의 새로운 프로필이 완성되었습니다!</h2>
      {/* profile 데이터가 있을 때만 p 태그를 렌더링합니다. */}
      {profile && (
        <>
          <h2><strong>-{profile.nickname || '정보 없음'}-</strong></h2>
          <p><strong>특징:</strong> {profile.character || '정보 없음'}</p>
        </>
      )}

      {/* 버튼들이 들어갈 자리 */}
      <div className="profile-display-actions">
        {/* 부모에게서 받은 버튼(children)들을 그대로 렌더링합니다. */}
        {children}
      </div>
    </div>
  );
}

export default NewProfileCard;